export const CardStyle = {
  padding: 2.5,
  width: '100%',
}

export const TypStyle = {
  marginBottom: 1,
}
